module.exports = __webpack_public_path__ + "img/Icon_Acrobat.2a740aee.svg";